module.exports = __webpack_public_path__ + "img/accomodation-1.39db1b71.webp";